import './style.scss';
import { ReactComponent as CloseBtn } from '../../../assets/images/crossCircleIcon.svg';

type CommonChipProps = {
  onClose?: () => void;
  withCloseBtn?: boolean;
  children: React.ReactNode;
};

export const CommonChip = ({
  onClose = undefined,
  withCloseBtn = true,
  children,
}: CommonChipProps) => (
  <div className="chip" data-testid="common-chip">
    {withCloseBtn && (
      <span className="chip__icon d-flex">
        <CloseBtn data-testid="common-chip__close-btn" onClick={() => onClose && onClose()} />
      </span>
    )}
    <span className="chip__text text-body-4">
      {children}
    </span>
  </div>
);
